import { Modal } from 'antd';

/**
 * Modals dismiss via Cancel / OK / Esc / outside click.
 */
const SAFE_DEFAULTS = {
  maskClosable: true,
  keyboard: true,
  closable: false,
};

Modal.defaultProps = {
  ...(Modal.defaultProps || {}),
  ...SAFE_DEFAULTS,
};

const wrapStaticMethod = (fn) => {
  if (typeof fn !== 'function') {
    return fn;
  }
  return (config = {}) =>
    fn({
      ...config,
      maskClosable: config.maskClosable ?? true,
      keyboard: config.keyboard ?? true,
      closable: config.closable ?? false,
    });
};

['info', 'success', 'error', 'warning', 'warn', 'confirm'].forEach((name) => {
  if (typeof Modal[name] === 'function') {
    Modal[name] = wrapStaticMethod(Modal[name]);
  }
});

export default function configureAntdModals() {
  return SAFE_DEFAULTS;
}
